import { useNavigate } from 'react-router';
import { Building2, User, Users, Shield, Globe, Calendar, CreditCard, Bell, Lock, HelpCircle, ChevronRight, Briefcase, MapPin, Clock, FileText, SlidersHorizontal } from 'lucide-react';

const SETTING_GROUPS = [
  {
    title: 'Company',
    items: [
      { label: 'Business Profile', description: 'Name, logo, address, fiscal year', icon: Building2, path: '/settings/business' },
      { label: 'Departments', description: 'Manage org structure', icon: Briefcase, path: '/settings/departments' },
      { label: 'Designations', description: 'Job titles & grades', icon: Users, path: '/settings/designations' },
      { label: 'Customize Employee Fields', description: 'Pick which fields appear on the employee form', icon: SlidersHorizontal, path: '/settings/employee-fields' },
    ],
  },
  {
    title: 'People',
    items: [
      { label: 'Users & Access', description: 'Invite team members', icon: Users, path: '/settings/users' },
      { label: 'Roles & Permissions', description: 'Custom permission sets', icon: Shield, path: '/settings/roles' },
      { label: 'Leave Policies', description: 'Leave types & entitlements', icon: Calendar, path: '/settings/leave-policies' },
    ],
  },
  {
    title: 'Attendance',
    items: [
      { label: 'Attendance Policies', description: 'Work hours, grace time', icon: Clock, path: '/settings/attendance-policies' },
      { label: 'Shifts', description: 'Shift schedules', icon: Clock, path: '/settings/shifts' },
      { label: 'Holidays', description: 'National & company holidays', icon: Calendar, path: '/settings/holidays' },
      { label: 'Geofencing', description: 'Office location & radius', icon: MapPin, path: '/settings/geofencing' },
    ],
  },
  {
    title: 'Payroll',
    items: [
      { label: 'Bank & Statutory', description: 'Company bank account, PF/ESIC/TAN numbers', icon: CreditCard, path: '/settings/payroll-bank' },
      { label: 'Salary Components', description: 'Earnings & deductions config', icon: CreditCard, path: '/settings/salary-components' },
      { label: 'Payslip Templates', description: 'Payslip branding', icon: FileText, path: '/settings/payslip-templates' },
    ],
  },
  {
    title: 'Account',
    items: [
      { label: 'Plan & Billing', description: 'Current plan, upgrade, payment', icon: CreditCard, path: '/settings/plan' },
      { label: 'Account Settings', description: 'Profile, password, 2FA', icon: User, path: '/settings/account' },
      { label: 'Privacy & Data', description: 'Data export & deletion', icon: Lock, path: '/settings/privacy' },
      { label: 'Help & Support', description: 'Docs, tickets, feedback', icon: HelpCircle, path: '/settings/help' },
    ],
  },
];

export default function SettingsPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6 fade-in max-w-2xl">
      <h1 className="text-[22px] font-bold text-[var(--text-primary)]">Settings</h1>
      {SETTING_GROUPS.map(group=>(
        <div key={group.title}>
          <p className="text-[11px] font-semibold uppercase tracking-widest text-[var(--text-tertiary)] mb-2 px-1">{group.title}</p>
          <div className="card p-0 overflow-hidden divide-y divide-[var(--border)]">
            {group.items.map(item=>{
              const Icon = item.icon;
              return (
                <button key={item.path} onClick={()=>navigate(item.path)}
                  className="w-full flex items-center gap-4 px-5 py-4 hover:bg-[var(--bg-muted)] transition-colors text-left">
                  <div className="w-9 h-9 rounded-[10px] bg-[var(--accent-muted)] flex items-center justify-center shrink-0">
                    <Icon size={16} className="text-[var(--accent)]"/>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[14px] font-semibold text-[var(--text-primary)]">{item.label}</p>
                    <p className="text-[12px] text-[var(--text-secondary)]">{item.description}</p>
                  </div>
                  <ChevronRight size={14} className="text-[var(--text-tertiary)] shrink-0"/>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
